import React from 'react'
import {func, string, bool} from 'prop-types'

const Button = ({ id, buttontext, buttontype, onclick, additionalClass, iconBefore, iconAfter, disabled, tabIndex, imgAfter, imgAfterAlt }) => {
	return (
	<button id={id} type={buttontype} onClick={onclick} className={additionalClass} disabled={disabled} tabIndex={tabIndex}>
			{iconBefore && <i className={iconBefore + ' icon-padding-right'} />}
			<p>{buttontext}</p>
			{iconAfter && <i className={iconAfter + ' icon-padding-left'} />}
			{imgAfter && <img src={imgAfter} alt={imgAfterAlt} />}
		</button>
	)
}

Button.propTypes = {
	id: string,
	buttontext: string.isRequired,
	onclick: func,
	iconlink: string,
	additionalClass: string,
	disabled: bool, 
	tabIndex: string,
	imgAfter: string,
	imgAfterAlt: string
}

Button.defaultProps = {
	id: "0",
	buttontype: 'button',
	onclick: () => {},
	additionalClass: '',
	disabled: false,
	tabIndex: "0",
	imgAfterAlt: ""
}

export default Button
